import React from 'react';
import './StatisticsModal.css';

const StatisticsModal = ({ isOpen, onClose, date, data, loading, error }) => {
  if (!isOpen) return null;

  const formatDate = (dateString) => {
    const d = new Date(dateString);
    return d.toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const formatTime = (dateString) => {
    if (!dateString) return '-';
    const d = new Date(dateString);
    return d.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>📊 Relatório de Estatísticas</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="report-date">
            <strong>Data:</strong> {formatDate(date)}
          </div>

          {loading && (
            <div className="loading-message">
              <div className="spinner"></div>
              <p>A carregar estatísticas...</p>
            </div>
          )}

          {error && (
            <div className="error-message">
              <p>❌ Erro ao carregar estatísticas: {error}</p>
            </div>
          )}

          {!loading && !error && data && data.length === 0 && (
            <div className="no-data-message">
              <p>📭 Sem dados de estatísticas para esta data.</p>
            </div>
          )}

          {!loading && !error && data && data.length > 0 && (
            <div className="statistics-container">
              {data.map((stat, index) => (
                <div key={stat.id || index} className="ronda-stats-card">
                  <div className="ronda-header">
                    <h3>{stat.ronda.codigo} - {stat.ronda.nome}</h3>
                    <span className="entity-badge">{stat.ronda.entidade}</span>
                  </div>

                  <div className="metrics-grid">
                    <div className="metric-card">
                      <div className="metric-main">
                        <span className="metric-icon">👥</span>
                        <span className="metric-title">Pessoas</span>
                        <span className="metric-value">{stat.metricas.pessoas_assistidas.total}</span>
                      </div>
                      <div className="metric-details">
                        <div>Média: {stat.metricas.pessoas_assistidas.media_por_local.toFixed(1)} | Paragens: {stat.metricas.pessoas_assistidas.total_paragens_com_assistencias}</div>
                      </div>
                    </div>

                    <div className="metric-card">
                      <div className="metric-main">
                        <span className="metric-icon">🍽️</span>
                        <span className="metric-title">Refeições</span>
                        <span className="metric-value">{stat.metricas.refeicoes?.total || 0}</span>
                      </div>
                      <div className="metric-details">
                        <div>Média: {(stat.metricas.refeicoes?.media_por_local || 0).toFixed(1)}</div>
                      </div>
                    </div>

                    <div className="metric-card">
                      <div className="metric-main">
                        <span className="metric-icon">🚗</span>
                        <span className="metric-title">Km</span>
                        <span className="metric-value">{stat.metricas.distancia.total_km.toFixed(1)}</span>
                      </div>
                    </div>

                    <div className="metric-card">
                      <div className="metric-main">
                        <span className="metric-icon">🙋</span>
                        <span className="metric-title">Volunt.</span>
                        <span className="metric-value">{stat.metricas.voluntarios.media ? stat.metricas.voluntarios.media.toFixed(1) : '-'}</span>
                      </div>
                      <div className="metric-details">
                        <div>Min: {stat.metricas.voluntarios.minimo || '-'} | Max: {stat.metricas.voluntarios.maximo || '-'}</div>
                      </div>
                    </div>

                    <div className="metric-card">
                      <div className="metric-main">
                        <span className="metric-icon">⏱️</span>
                        <span className="metric-title">Tempo</span>
                        <span className="metric-value">{(stat.metricas.tempo.viagem_minutos + stat.metricas.tempo.paragem_minutos) || stat.metricas.tempo.duracao_minutos || 0} min</span>
                      </div>
                      <div className="metric-details">
                        <div>🚗 {stat.metricas.tempo.viagem_minutos || 0} | 🅿️ {stat.metricas.tempo.paragem_minutos || 0}</div>
                        {stat.metricas.tempo.primeiro_evento && (
                          <div>{formatTime(stat.metricas.tempo.primeiro_evento)}-{formatTime(stat.metricas.tempo.ultimo_evento)}</div>
                        )}
                      </div>
                    </div>

                    <div className="metric-card">
                      <div className="metric-main">
                        <span className="metric-icon">📍</span>
                        <span className="metric-title">Eventos</span>
                        <span className="metric-value">{stat.metricas.eventos.total}</span>
                      </div>
                      <div className="metric-details">
                        <div>Parag: {stat.metricas.eventos.total_paragens} | Locais: {stat.metricas.eventos.locais_unicos}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatisticsModal;
